import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { FmPreset } from '@fm-adk-primeng/themes';
import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { requestHeadersInterceptor } from './core/interceptors/request-headers.interceptor';
import { chassisResponseInterceptor } from './core/interceptors/chassis-response.interceptor';
import { envRoleInterceptor } from './core/interceptors/env-role.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideHttpClient(withInterceptors([requestHeadersInterceptor, envRoleInterceptor, chassisResponseInterceptor])),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.initializeUserDetailsAndRedirectToLogin();
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: FmPreset,
        options: {
          darkModeSelector: 'none'
        }
      }
    })
  ]
};
